<template>
    <div class="wrap"> 
        <Fontnavbar title="客服"/>
        <div class="font">
            <img :src="imgDomain+messag.wechat_img" alt="" class="font_img">
            <!-- <img src="https://geshow-shop.oss-cn-hangzhou.aliyuncs.com/customer_wechat_img/20210317/f9177639951064a5a579ec8341a164f4.jpg" class="font_img" width="64" alt="暂无" title="暂无"> -->
        </div>
        <div v-if="messag" style="font-size: 16px;text-align: center">微信：{{ messag.qq }}</div>
        <div class="bottom">
            请扫码联系您的专属客服！
            或电话联系：
            400-6868-210
        </div>
    </div>
    
</template>
<script>
import Fontnavbar from "../../components/Navbar.vue";
import { post } from "../../request.js";
import {  get_customer } from "../../api.js";
export default{
   components:{
    Fontnavbar
   },
   data(){
       return{
           messag:[],
           imgDomain: process.env.VUE_APP_IMG_URL,
       };
   },
    mounted(){  
       post(get_customer, {}).then(res => {
			if (res.code == 200) {
                this.messag=res.data;
			} else{
				this.$message({
                  message: res.msg,
                  type: 'warning'
                  })
			}
			});
   },
}
</script>

<style lang="less" scoped>
.wrap{
    height: 100vh;
    width: 100%;
}
.font{
    margin-top: 20%;
    margin-left: 22%;
    width:200px;
    height: 200px;
}

.font .font_img{
    height: 100%;
    width: 100%;
}

.bottom{
    padding-top: 10%;
    margin-left: 10%;
    margin-right: 5%;
}
</style>
